import ms from "ms";
import { Token } from "./tokens.js";

export class Primitive<V> {
  static STRING = new Primitive<string>(
    function parse(x: string) { return x.trim(); },
    function serialize(x) { return Token.serializeWord(x); },
    function cmp(a, b) { return a < b ? -1 : a > b ? 1 : 0; }
  )

  static INTEGER = new Primitive<number>(
    function parse(txt: string) {
      const x = parseInt(txt.trim().toLowerCase(), 10);
      return isNaN(x) ? undefined : x;
     },
    function serialize(x) { return Token.serializeWord(String(x)); },
    function cmp(a, b) { return a - b; }
  )

  static DURATION = new Primitive<number>(
    function parse(txt: string) {
      // Parse float number and suffix, which is one of the following:
      // - ns, nanos, nanosecond, nanoseconds
      // - ms, millis, millisecond, milliseconds
      // - s, sec, second, seconds
      // - m, min, minute, minutes
      // - h, hs, hour, hours
      txt = txt.trim().toLowerCase();
      const x = parseFloat(txt);
      if (isNaN(x))
        return undefined;
      if (/\d+(ns|nanos|nanosecond|nanoseconds)$/.test(txt))
        return x / 1000;
      if (/\d+(ms|millis|millisecond|milliseconds)$/.test(txt))
        return x;
      if (/\d+(s|sec|second|seconds)$/.test(txt))
        return x * ms('1 second');
      if (/\d+(m|min|mins|minute|minutes)$/.test(txt))
        return x * ms('1 minute');
      if (/\d+(h|hour|hours)$/.test(txt))
        return x * ms('1 hour');
      return x;
     },
    function serialize(x) { return Token.serializeWord(String(x)); },
    function cmp(a, b) { return a - b; }
  )

  static PERCENTAGE = new Primitive<number>(
    function parse(txt: string) {
      txt = txt.trim().toLowerCase();
      const hasPercent = txt.endsWith('%');
      const x = parseFloat(hasPercent ? txt.slice(0, -1) : txt);
      if (isNaN(x))
        return undefined;
      // Snap to Float32 precision to match flip rate storage (Float32Array).
      return Math.fround(x / 100);
    },
    function serialize(x) { return Token.serializeWord(String(x * 100) + '%'); },
    function cmp(a, b) { return a - b; }
  )

  constructor(
    public readonly parse: (x: string) => V|undefined,
    public readonly serialize: (x: V) => string,
    public readonly cmp: (a: V, b: V) => number,
  ) {

  }
}
